/* IMPORT */
import untrack from './untrack.js';
import { SYMBOL_UNTRACKED } from '../symbols.js';
import { isFunction } from '../utils.js';
function untracked(fn) {
    const untracked = isFunction(fn) ? (...args) => untrack(() => fn(...args)) : () => fn;
    untracked[SYMBOL_UNTRACKED] = true;
    return untracked;
}
/* EXPORT */
export default untracked;
